import React from 'react';

export default props => {
  const { stations, yScale, margin, rulerWidth } = props;
  return (
    <g className="station">
      {stations.map(station => (
        <g
          key={station.name}
          transform={`translate(${margin.left},${yScale(station.distance)})`}
        >
          <text x={-20} dy=".3em" onClick={() => console.log(station)}>
            {station.name}
          </text>
          <line x2={rulerWidth} />
        </g>
      ))}
    </g>
  );
};
